/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import { Random } from "random-js";
import axios from '@/axios.js'
import con from '@/firebase/firebaseInit.ts'
import firebase from 'firebase';
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
const chatgroupRef = con.eventDB.collection(cn).doc('group-chat').collection('chat-rooms')
const storageRef = con.storageRef
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var UploadFilesAPI = con.UploadFilesAPI
var CreateChatGroup = con.CreateChatGroup
var EditCHatGroup = con.EditCHatGroup
var DeleteUserFromRoom = con.DeleteUserFromRoom
var UnpublishMessage = con.UnpublishMessage
var PostChatMessage = con.PostChatMessage
var TranslateChatMessage = con.TranslateChatMessage
var GetChatStats = con.GetChatStats
var GetRoomStats = con.GetRoomStats
var BroadcastRoomMessage = con.BroadcastRoomMessage

export default {
    fetchChatgroups({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            chatgroupRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    //if(doc.data().userIdList && doc.data().userIdList.length > 2){
                        let docObj = doc.data();
                        markers.push(docObj)
                    //}
                })
                commit('SET_CHATGROUPS', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })
        })
    },
    getBroadcastMessagesofGroup(context, id) {
        return new Promise((resolve, reject) => {
            const markers = []
            chatgroupRef.doc(`${id}`).collection('broadcasts').get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    //if(doc.data().userIdList && doc.data().userIdList.length > 2){
                        let docObj = doc.data();
                        markers.push(docObj)
                    //}
                })
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })
        })
    },
    fetchChatgroupsStat({ commit }) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "eventId": Session_Event_Id,
                "clientId": Session_Client_Id,
                "instanceId": "OA_UAT"
            }

            axios.post(GetChatStats, requestData, { headers: headers }).then(response => {
                //console.log(response.data)
                commit('SET_CHATGROUPSTAT', response.data.rows)
                resolve(response.data.rows);
            }).catch(err=>{ reject(err) });

        });
    },
    getRoomStats(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "eventId": Session_Event_Id,
                "clientId": Session_Client_Id,
                "instanceId": "OA_UAT",
                "roomId": field.roomId,
                "maxRank": field.maxRank
            }

            axios.post(GetRoomStats, requestData, { headers: headers }).then(response => {
                //console.log(response.data)
                resolve(response.data);
            }).catch(err=>{ reject(err) });

        });
    },
    fetchChatgroup(context, id) {
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {
                        roomName: null,
                        roomIconUrl: null,
                        groupAdminUserId: null,
                        userIdList: [],
                        roomDescription: null
                    }
                })
            } else {
                let docObj = new Object
                chatgroupRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()
                    resolve({
                        status: 200,
                        data: docObj
                    })             
                })
            }
        })
    },
    updateChatgroup(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": Session_Event_Id,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                 "data": field.data
            }

            axios.post(EditCHatGroup, requestData, { headers: headers }).then(response => {
              if(response.data.status == 0)
                resolve({status:200,message:"Data Updated"});
              else
                resolve({status:500,message:"Data Not Updated"});
            }).catch(err=>{ reject(err) });

        })
    },
    addChatgroup(context, field) {   
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": Session_Event_Id,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                 "data": field.data
            }

            axios.post(CreateChatGroup, requestData, { headers: headers }).then(response => {
              if(response.data.status == 0)
                resolve({status:200,message:"Data Added", id: response.data.roomId});
              else
                resolve({status:500,message:"Data Not Added", id: null});
            }).catch(err=>{ reject(err) });

        });
    },
    sendBroadcastMessage(context, field) {   
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": Session_Event_Id,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"
                },
                "data": field
            }

            axios.post(BroadcastRoomMessage, requestData, { headers: headers }).then(response => {
              if(response.data.status == 0)
                resolve({status:200,message:"Data Added"});
              else
                resolve({status:500,message:"Data Not Added"});
            }).catch(err=>{ reject(err) });

        });
    },
    uploadFiles(context, field){
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {   
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },                     
                files: field
            };
            axios.post(UploadFilesAPI, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0)
                    resolve({status:200, data:res.data.data})
                else
                    resolve({status:500, data:[]})
            }).catch(err=>{ reject(err) })
        })
    },
    getChatGroupMessages({commit}, roomId){
        return new Promise((resolve, reject) => {
            let markers = []
            let groupChatMessagingListener = chatgroupRef.doc(roomId).collection("message-thread");
            groupChatMessagingListener.get().then(function (querySnapshot) {
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())                                       
                })
                commit('SET_CHATGROUPMESSAGES', markers) 
                resolve(markers)
            }).catch(err=>{
                reject(err)
            })
            
        })
    },
    postChatMessage(context, payload){
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {   
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id
                },                     
                "data": payload
            };
            axios.post(PostChatMessage, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0)
                    resolve({status:200, message:"Data Added"})
                else       
                    resolve({status:500, message:"Data Not Added!"})    
            }).catch(err=>{ reject(err) })
        })
    },
    translateMessages({commit, state}, field){
        let messages = state.chatgroupmessages.map(item=>{
            return {
                msgId: item.id,
                text: item.msgText
            }
        })
        let accessToken = ls.getSessionValueByKey('Session_AccessToken');
        let headers = {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${accessToken}`
        }
        let requestData = {   
            "key": {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
            },                     
            "data": {
                "targetLanguage": field.language,
                "rooms": [
                    {
                        "roomId": field.roomId,
                        "messages": messages
                    }

                ]
            }

        };
        axios.post(TranslateChatMessage, requestData, { headers: headers }).then(function (res) {
            if(res.data.status == 0)
                commit('SET_TRANSLATEDCHATGROUPMESSAGES', res.data.result[0].messages)            
        })
    },
    clearChatGroupMessages({commit}){
        commit('SET_CHATGROUPMESSAGES', [])
    },
    listenChatGroupMessages(context, field){
        //return new Promise((resolve, reject) => {
            let state = context.state;
            let groupChatMessagingListener = chatgroupRef.doc(field.roomId).collection("message-thread");
            groupChatMessagingListener.orderBy("sentAtDtm").onSnapshot(function (res) {
                const chnages = res.docChanges();
                let totallength = chnages.length;
                let count = 0;
                chnages.forEach(change => {  
                    count++;
                    let msgIndex = state.chatgroupmessages.findIndex((u) => u.id == change.doc.id)
                    if(change.type == 'added')
                        if(change.doc.data().isPublished == undefined || change.doc.data().isPublished == true)
                            if(msgIndex <= 0){
                                context.commit('SET_CHATGROUPMESSAGESADD', change.doc.data())
                            }
                    if(change.type == 'modified'){
                        if(change.doc.data().isPublished == undefined || change.doc.data().isPublished == true){   
                            if(msgIndex >= 0){
                                context.commit('SET_CHATGROUPMESSAGESMODIFY', change.doc.data())
                            }
                            else{
                                context.commit('SET_CHATGROUPMESSAGESADD', change.doc.data())
                            }
                        }
                        else
                            context.commit('SET_CHATGROUPMESSAGESREMOVE', change.doc.id)
                    }
                    if(change.type == 'removed')
                        context.commit('SET_CHATGROUPMESSAGESREMOVE', change.doc.id)         
                })
                if(count==totallength && field.language)
                    context.dispatch('translateMessages', field);
            /*}),error =>{
                reject(err)
            }*/
        })
    },
    unpublishMessage({ commit }, field) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {   
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },                     
                "data": {
                    "roomId": field.roomId,
                    "msgId": field.msgId
                }

            };
            axios.post(UnpublishMessage, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0)
                    resolve({status:200, message:"Message removed successfully."})
                else
                    resolve({status:500, message:"Message not removed!"})
            }).catch(err=>{ reject(err) })
        })
    },
    deleteUserFromRoom({ commit }, field) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey('Session_AccessToken');
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${accessToken}`
            }
            let requestData = {   
                "key": {
                    "instanceId": "OA_UAT",
                    "clientId": Session_Client_Id,
                    "eventId": Session_Event_Id,
                },                     
                "data": {
                    "roomId": field.roomId,
                    "userIdList": field.userIdList
                }

            };
            axios.post(DeleteUserFromRoom, requestData, { headers: headers }).then(function (res) {
                if(res.data.status == 0)
                    resolve({status:200, message:"Data removed successfully."})
                else
                    resolve({status:500, message:"Data not removed!"})
            }).catch(err=>{ reject(err) })
        })
    },
    getSettings(context) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('chat').doc('ChatGroupSettings').get().then(function (doc) {
                if (doc.exists) {
                    resolve(doc.data())
                } else {
                    resolve(null)
                }

            })
        })
        return promise;
    },
    saveSettings(context, field) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('chat').doc('ChatGroupSettings').get().then(function (doc) {
                if (doc.exists) {
                    con.eventDB.collection(cn).doc("Settings").collection('chat').doc('ChatGroupSettings').update(field.settingsData)
                    resolve({ message: 'Data Updated.' })
                } else {
                    con.eventDB.collection(cn).doc("Settings").collection('chat').doc('ChatGroupSettings').set(field.settingsData)
                    resolve({ message: 'Data Updated.' })
                }

            })
        })
        return promise;
    },
}